// extracted by mini-css-extract-plugin
module.exports = {"wrap":"tenantInfoDialog_wrap__2lEC-","sectionTit":"tenantInfoDialog_sectionTit__2vc_s","footer":"tenantInfoDialog_footer__1W4xJ","tabs":"tenantInfoDialog_tabs__3OGZs"};